import BaseClient from './BaseClient';

class OrgUnitBillingClient extends BaseClient {
    updateInformation(teamId, orgUnitId, data) {
        return this.makeCoreApiRequest(
            `/api/v3/teams/${teamId}/org-units/${orgUnitId}/billing/information`,
            'put',
            data
        );
    }

    updateBillingEmail(teamId, orgUnitId, data) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/org-units/${orgUnitId}/billing/email`, 'put', data);
    }

    updatePaymentMethod(teamId, orgUnitId, stripePaymentMethod) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/org-units/${orgUnitId}/billing/payment-method`, 'put', {
            stripe_payment_method: stripePaymentMethod,
        });
    }

    getProformaInvoice(teamId, orgUnitId, periodDate) {
        const params = periodDate ? { period_date: periodDate } : null;
        return this.makeCoreApiRequest(
            `/api/v3/teams/${teamId}/org-units/${orgUnitId}/billing/proforma-invoice`,
            'get',
            null,
            params
        );
    }

    getInvoices(teamId, orgUnitId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/org-units/${orgUnitId}/billing/invoices`);
    }
}

export default new OrgUnitBillingClient();
